import { useEffect, useState } from 'react';
import {
  clearLoginLockout,
  formatLockoutRemaining,
  getLoginLockout,
  parseLoginErrorDetail,
  saveLoginLockout,
} from '../utils/loginLockout';

export function useLoginLockout(email) {
  const [lockoutUntil, setLockoutUntil] = useState(null);
  const [remainingLabel, setRemainingLabel] = useState('');

  useEffect(() => {
    const storedUntil = getLoginLockout(email);
    setLockoutUntil(storedUntil);
  }, [email]);

  useEffect(() => {
    if (!lockoutUntil) {
      setRemainingLabel('');
      return undefined;
    }

    const tick = () => {
      if (Date.now() >= lockoutUntil) {
        clearLoginLockout();
        setLockoutUntil(null);
        setRemainingLabel('');
        return;
      }
      setRemainingLabel(formatLockoutRemaining(lockoutUntil));
    };

    tick();
    const interval = window.setInterval(tick, 1000);
    return () => window.clearInterval(interval);
  }, [lockoutUntil]);

  const applyLockoutFromError = (error) => {
    const detail = parseLoginErrorDetail(error);
    if (detail?.code !== 'ACCOUNT_LOCKED') {
      return false;
    }
    const retryAfter = Number(detail.retry_after_seconds) || 15 * 60;
    const until = saveLoginLockout(email, retryAfter);
    setLockoutUntil(until);
    return true;
  };

  return {
    isLocked: Boolean(lockoutUntil),
    lockoutUntil,
    remainingLabel,
    applyLockoutFromError,
    clearLockout: () => {
      clearLoginLockout();
      setLockoutUntil(null);
    },
  };
}
